const IoTProducts = () => {
	return (
		<>
			<h1 className="display-3 mb-4">IOT Products</h1>
			<h2>Product Engineering</h2>
			
		</>
	)
}
export default IoTProducts